export const scrollbarClasses =
  "tw-scrollbar-thin tw-scrollbar-thumb-solGray tw-scrollbar-track-solBlack tw-scrollbar-thumb-hover-solYellow";
